import { SCORE_LEVELS } from '../lib/constants';

/**
 * Score gauge 0-100, estilo credit score. SVG puro, sin dependencias.
 */
export default function ScoreGauge({ score = 0, level = 'critico', size = 220, label = 'Score de cumplimiento' }) {
  const s = Math.max(0, Math.min(100, Number(score) || 0));
  const meta = SCORE_LEVELS[level] || SCORE_LEVELS.critico;

  // Arco de 240° comenzando en 150°
  const start = 150;
  const end = 30 + 360; // 390 => visualmente 30
  const totalDeg = 240;
  const currentDeg = (s / 100) * totalDeg;

  const cx = size / 2;
  const cy = size / 2;
  const r = size / 2 - 18;
  const strokeWidth = 14;

  const polar = (deg) => {
    const rad = (deg * Math.PI) / 180;
    return { x: cx + r * Math.cos(rad), y: cy + r * Math.sin(rad) };
  };
  const arcPath = (fromDeg, toDeg) => {
    const a = polar(fromDeg);
    const b = polar(toDeg);
    const large = toDeg - fromDeg > 180 ? 1 : 0;
    return `M ${a.x} ${a.y} A ${r} ${r} 0 ${large} 1 ${b.x} ${b.y}`;
  };

  return (
    <div className="flex flex-col items-center" data-testid="score-gauge">
      <svg width={size} height={size * 0.72} viewBox={`0 0 ${size} ${size * 0.85}`} className="overflow-visible">
        <path
          d={arcPath(start, start + totalDeg)}
          fill="none"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          className="pv-score-ring-track"
        />
        {s > 0 && (
          <path
            d={arcPath(start, start + currentDeg)}
            fill="none"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            className={meta.ring}
          />
        )}
        {/* Ticks 0 / 100 */}
        <text x={polar(start).x - 6} y={polar(start).y + 22} fontSize="10" fill="#9CA3AF" fontFamily="JetBrains Mono">0</text>
        <text x={polar(start + totalDeg).x - 10} y={polar(start + totalDeg).y + 22} fontSize="10" fill="#9CA3AF" fontFamily="JetBrains Mono">100</text>
      </svg>
      <div className="-mt-16 flex flex-col items-center">
        <span className="text-6xl font-semibold text-[#1C2329] tabular-nums" data-testid="score-value">{s}</span>
        <span className="text-xs text-[#6B7280] mt-1 tracking-wide uppercase">{label}</span>
        <span
          className="mt-3 inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-medium"
          style={{ background: meta.bg, color: meta.text, border: `1px solid ${meta.color}33` }}
          data-testid="score-level"
        >
          <span className="w-1.5 h-1.5 rounded-full" style={{ background: meta.color }} />
          {meta.label}
        </span>
      </div>
    </div>
  );
}
